import React, {useEffect} from 'react';
import './App.css';
import Layout from "./components/layout/layout";
import {ShowLanding} from "./pages/show-landing";
import {Router as BrowserRouter} from "react-router-dom";
import { Route, Switch, Redirect } from 'react-router-dom';
import {VRLanding} from "./pages/vr-landing";
import { createBrowserHistory } from 'history';
import {requestPermissions} from "./lib/request-permissions";
import * as THREE from 'three';
window.THREE = THREE;
function App() {
    useEffect(() => {
        let listeners = 'touch,scroll,click';
        const requestAndUnsubscribe = () => {
            requestPermissions();
            listeners.split(',').map(event => document.removeEventListener(event, requestAndUnsubscribe))
        };

        listeners.split(',').map(event => document.addEventListener(event, requestAndUnsubscribe))
    }, []);

    const history = createBrowserHistory({
        basename: '/hologram-icons'
    });

    return (

          <BrowserRouter history={history} >
              <Switch>
                  <Route path="/" exact={true} render={() =>
                      <Layout>
                         <ShowLanding />
                      </Layout>
                  } />
                  <Route path="/vr" render ={ () =>
                      <Layout disableNavbar={true}>
                     <VRLanding />
                      </Layout>
                  } />
                  <Route render={() => <Redirect to={"/hologram-icons/"} />} />
              </Switch>
          </BrowserRouter>

  );
}

export default App;
